module.exports = __webpack_public_path__ + "img/vertical_6_6_8019.e3d5eee5.png";